/* eslint-disable import/prefer-default-export */
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: '66px',
    '& .panel-toggler': {
      visibility: 'hidden',
    },
    '& .MuiPaper-root.error': {
      position: 'absolute',
      top: '66px',
      [theme.breakpoints.only('xs')]: {
        position: 'relative',
        maxHeight: '105px',
        top: '0',
      },
    },
    '& .MuiPaper-root.success': {
      position: 'absolute',
      top: '66px',
      [theme.breakpoints.only('xs')]: {
        position: 'relative',
        maxHeight: '105px',
        top: '0',
      },
    },
  },
  leftPadding: {
    paddingLeft: '3px',
    position: 'fixed',
    bottom: 0,
  },
}));
